import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home.jsx';
import AiScreen from './pages/AiScreen';
import LoginPage from './components/LoginPage';
import { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';



function App() {

  const [user, setUser] = useState(null);

	const getUser = async () => {
		try {
			const url = `${process.env.REACT_APP_SERVER_BASE_URL}/auth/login/success`;
			const { data } = await axios.get(url, { withCredentials: true });
      console.log("user",data)
			setUser(data.user);
      localStorage.setItem('userVal',JSON.stringify(data.user))
      localStorage.setItem('authId',JSON.stringify(data.token))
		} catch (err) {
			console.log(err);
		}
	};

  useEffect(() => {
		getUser();
	}, []);
  return (
    <>

      <Routes>
        <Route path="/" element={<Home user={user}/>} />
        <Route path="/go-beta" element={<AiScreen />} />
        <Route path='/login' element={<LoginPage />} />
      </Routes>

    </>
  );
}

export default App;
